import {
  Box,
  Button,
  FormControlLabel,
  Paper,
  Divider,
  Grid,
  Switch,
  TextField,
  Typography,
  Checkbox,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CancelIcon from "@material-ui/icons/Cancel";
import CircularProgress from "@material-ui/core/CircularProgress";
import HttpService from "../../services/HttpService.js";
import UrlService from "../../services/UrlService.js";
import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { EmailRegex } from "../inputs/regex";

const ConfirmEmail = (props) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(props.email);
  const [loading, setLoading] = useState("none");
  const [checked, setChecked] = useState(false);
  const [emailRequired, setEmailRequired] = useState(true);
  const [validators, setValidators] = useState(["required", "isEmail"]);

  const handleAdd = () => {
    setLoading("block");
    HttpService.post(
      `${UrlService.apiDomain()}api/sign_pregenerated_documents/${props.id}`,
      {
        email: email,
      }
    )
      .then((response) => {
        if (!response.data.success) {
          console.log(response);
          setLoading("none");
          if (response.data.message) {
            alert(response.data.message);
          }
          alert(
            "Digisign potřebuje ještě cca 10-20 vteřin na přípravu podpisů. Prosím, zkuste znovu kliknout tlačítko 'Podepsat dokumenty' za okamžik"
          );
          /*
                    if (response.data.message.indexOf('jeden z')) {
                        alert("Digisign potřebuje ještě cca 10-20 vteřin na přípravu podpisů. Prosím, zkuste znovu kliknout tlačítko 'Podepsat dokumenty' za okamžik");
                    } else {
                        alert("Chyba: " + response.data.message);
                    }
                    */
        } else {
          if (response.data.urls.length > 0) {
            response.data.urls.forEach((item) => {
              setTimeout(() => {
                window.open(item, "_blank");
              }, 1000); // Задержка в 1 секунду между открытием каждого окна
            });
            setLoading("none");
          }
          // window.open(response.data.url, "_blank");
        }

        props.handleClose();
        // setEmail('');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCheckChange = () => {
    setEmail("");
    setEmailRequired(checked);
    if (checked) {
      setValidators(["required", "isEmail"]);
    } else {
      setValidators([]);
    }
    setChecked(!checked);
  };

  return (
    <Paper
      elevation={12}
      sx={{
        maxWidth: 620,
        mx: "auto",
        p: 2,
      }}
    >
      <Typography color="textPrimary" variant="h6">
        {t("Ověření emailové adresy")}
      </Typography>
      <Divider sx={{ marginBottom: 3 }} />
      <ValidatorForm
        onSubmit={handleAdd}
        onError={(errors) => console.log(errors)}
      >
        <Grid container spacing={3}>
          <Grid item xs={8}>
            <TextValidator
              fullWidth
              label={t("Email")}
              validators={validators}
              required={emailRequired}
              disabled={checked}
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              variant="outlined"
              errorMessages={["Email je povinný", "Email není validní"]}
            />
          </Grid>
          <Grid item xs={2}>
            {props.email_verified == true && (
              <CheckIcon fontSize="large" style={{ color: "green" }} />
            )}
            {props.email_verified == false && (
              <CancelIcon fontSize="large" style={{ color: "red" }} />
            )}
          </Grid>

          <Grid item xs={2}>
            <CircularProgress sx={{ display: loading }} />
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={checked}
                  onChange={handleCheckChange}
                  sx={{ ml: 1 }}
                />
              }
              label="Uživatel nemá emailovou adresu"
            />
          </Grid>

          <Grid item xs={12}>
            <Button color="primary" fullWidth variant="contained" type="submit">
              {t("Uložit a podepsat")}
            </Button>
          </Grid>
        </Grid>
      </ValidatorForm>
    </Paper>
  );
};

export default ConfirmEmail;
